module.exports = __webpack_public_path__ + "img/SmallDedeLogo_black.6a75d9bf.svg";